<template>
  <div>
    <sizes-form
      :sidebar-active.sync="sidebarActive"
      :size-id="selectedSizeId"
      @refreshData="getSizes"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Mostrar</label>
            <v-select
              v-model="perPage"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
            />
            <b-button
              v-if="userData().role === 'admin'"
              variant="outline-primary"
              @click="openCreateForm"
            >
              Nueva Talla
            </b-button>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Buscar (nombre, descripción o código externo)"
              />
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        class="position-relative"
        hover
        responsive
        small
        primary-key="id"
        show-empty
        empty-text="No se encontraron registros coincidientes"
        :busy="tableIsBusy"
        :items="sizesData"
        :fields="sizesFields"
        :per-page="perPage"
      >
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle" />
          </div>
        </template>

        <!-- Column: Id -->
        <template #cell(id)="data">
          <b-link
            class="font-weight-bold text-primary"
            @click="openEditForm(data.item.id)"
          >
            {{ data.item.id }}
          </b-link>
        </template>

        <!-- Column: Name -->
        <template #cell(name)="data">
          <b-link
            class="font-weight-bold text-primary"
            @click="openEditForm(data.item.id)"
          >
            {{ data.item.name }}
          </b-link>
        </template>

        <!-- Column: Description -->
        <template #cell(description)="data">
          <span class="text-nowrap">
            <div class="d-flex flex-column">
              <span class="text-body-heading">{{ data.item.description || 'Sin descripción' }}</span>
            </div>
          </span>
        </template>

        <!-- Column: External Code -->
        <template #cell(external_code)="data">
          <span class="text-nowrap">
            <div class="d-flex flex-column">
              <span class="text-body-heading">{{ data.item.external_code || 'Sin código' }}</span>
            </div>
          </span>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            :variant="data.item.status === 'Y' ? 'light-success' : 'light-danger'"
          >
            {{ data.item.status === 'Y' ? 'Activa' : 'Inactiva' }}
          </b-badge>
        </template>

        <!-- Column: Created At -->
        <template #cell(created_at)="data">
          <span class="text-nowrap">
            <div class="d-flex flex-column">
              <span class="text-body-heading">{{ data.item.created_at }}</span>
            </div>
          </span>
        </template>

        <!-- Column: Updated At -->
        <template #cell(updated_at)="data">
          <span class="text-nowrap">
            <div class="d-flex flex-column">
              <span class="text-body-heading">{{ data.item.updated_at }}</span>
            </div>
          </span>
        </template>

      </b-table>

      <div class="mx-2 mb-2">
        <b-row>
          <!-- Pagination info -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando del {{ dataMeta.from }} al {{ dataMeta.to }} de {{ dataMeta.total }} registros</span>
          </b-col>

          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalSizes"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from '@axios'
import vSelect from 'vue-select'
import SizesForm from './SizesForm.vue'

export default {
  components: {
    vSelect,
    SizesForm,
  },
  data() {
    return {
      // Sidebar
      sidebarActive: false,
      selectedSizeId: null,

      // Table
      tableIsBusy: false,
      sizesData: [],
      sizesFields: [
        {
          key: 'id',
          label: 'ID',
          sortable: true,
        },
        {
          key: 'name',
          label: 'Nombre',
          sortable: true,
        },
        {
          key: 'description',
          label: 'Descripción',
          sortable: true,
        },
        {
          key: 'external_code',
          label: 'Código Externo',
          sortable: true,
        },
        {
          key: 'status',
          label: 'Estado',
          sortable: true,
        },
        {
          key: 'created_at',
          label: 'Creada',
          sortable: true,
        },
        {
          key: 'updated_at',
          label: 'Actualizada',
          sortable: true,
        },
      ],

      // Search & Filter
      searchQuery: '',
      searchQueryTimeout: null,

      // Pagination
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      currentPage: 1,
      totalSizes: 0,
      dataMeta: {
        from: 0,
        to: 0,
        total: 0,
      },

      // Sort
      sortField: 'id',
      sortDirection: 'asc',
    }
  },
  computed: {
    userData() {
      return () => JSON.parse(localStorage.getItem('DuttonAuthUser'))
    },
  },
  watch: {
    searchQuery() {
      clearTimeout(this.searchQueryTimeout)
      this.searchQueryTimeout = setTimeout(() => {
        this.getSizes()
      }, 300)
    },
    perPage() {
      this.getSizes()
    },
    currentPage() {
      this.getSizes()
    },
  },
  mounted() {
    this.getSizes()
  },
  methods: {
    async getSizes() {
      this.tableIsBusy = true
      try {
        const params = {
          page: this.currentPage,
          perPage: this.perPage,
          query: this.searchQuery,
          sortField: this.sortField,
          sortDesc: this.sortDirection,
        }

        const response = await axios.get('size', { params })
        this.sizesData = response.data.data
        this.dataMeta = response.data.meta
        this.totalSizes = response.data.meta.total
      } catch (error) {
        console.error('Error fetching sizes:', error)
        this.makeToast('danger', 'Error', 'Error al cargar las tallas')
      } finally {
        this.tableIsBusy = false
      }
    },

    openCreateForm() {
      this.selectedSizeId = null
      this.sidebarActive = true
    },

    openEditForm(id) {
      this.selectedSizeId = id
      this.sidebarActive = true
    },
  },
}
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
